var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShore404 = function SvgShore404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 576,
    height: 251,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E2E8F0",
    d: "M0 184.5v-41.4L94.8 7.5h57.3v132.6h24.6v44.4h-24.6v39h-51.3v-39H0ZM104.4 63.9 54 140.1h50.4V63.9ZM201.827 111c0-34.4 6.6-61.5 19.8-81.3 13.4-19.8 34.9-29.7 64.5-29.7s51 9.9 64.2 29.7c13.4 19.8 20.1 46.9 20.1 81.3 0 34.8-6.7 62.1-20.1 81.9-13.2 19.8-34.6 29.7-64.2 29.7s-51.1-9.9-64.5-29.7c-13.2-19.8-19.8-47.1-19.8-81.9Zm118.2 0c0-20.2-2.2-35.7-6.6-46.5-4.4-11-13.5-16.5-27.3-16.5s-22.9 5.5-27.3 16.5c-4.4 10.8-6.6 26.3-6.6 46.5 0 13.6.8 24.9 2.4 33.9 1.6 8.8 4.8 16 9.6 21.6 5 5.4 12.3 8.1 21.9 8.1 9.6 0 16.8-2.7 21.6-8.1 5-5.6 8.3-12.8 9.9-21.6 1.6-9 2.4-20.3 2.4-33.9ZM398.73 184.5v-41.4l94.8-135.6h57.301v132.6h24.599v44.4h-24.599v39H499.53v-39h-100.8Zm104.4-120.6-50.4 76.2h50.4V63.9Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.482,
    cy: 241.671,
    fill: "#E5E7E9",
    opacity: 0.6,
    rx: 45.482,
    ry: 8.671,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5860D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M308.825 186.344c-18.641 19.761-7.136 30.712-.095 37.455M251.329 180.068c-21.339 21.334-18.839 29.235 0 53.336M204.582 164.251c2.201-25.491 12.075-40.565 22.074-47.021"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B6A6",
    fillRule: "evenodd",
    d: "M348.536 64.602c-10.22-11.35-28.279-10.694-58.238-12.264-29.959-1.57-47.85-4.11-59.201 6.11-11.35 10.22-10.694 28.279-12.265 58.238-1.57 29.958-4.109 47.85 6.111 59.2 10.22 11.351 28.279 10.695 58.237 12.265 29.959 1.57 47.851 4.11 59.201-6.11 11.351-10.22 10.695-28.279 12.265-58.238 1.57-29.959 4.11-47.85-6.11-59.2Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D0BE",
    fillRule: "evenodd",
    d: "M339.911 63.93c-9.502-11.057-26.333-10.373-54.247-11.836-27.918-1.463-44.585-3.903-55.187 6.1-10.602 10.003-10.031 27.629-11.564 56.877-1.533 29.248-3.943 46.717 5.556 57.774 9.498 11.056 26.329 10.376 54.246 11.839 27.914 1.463 44.581 3.899 55.187-6.104 10.603-10.003 10.032-27.629 11.565-56.877 1.533-29.248 3.942-46.718-5.556-57.774Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M325.256 122.864c-.655 4.773-3.278 9.041-7.44 12.028l-36.197 25.74c-.42.379-1.24.737-2.039.695-.399-.021-.803-.042-1.177-.463-1.178-.462-1.514-1.681-1.451-2.879l1.758-33.554-10.825 7.844c-8.324 5.972-19.846 4.167-25.818-4.157-2.986-4.162-3.934-9.018-3.283-13.791.651-4.772 3.278-9.041 7.44-12.027l36.197-25.74c.84-.758 2.039-.695 3.216-.233 1.177.463 1.51 1.682 1.447 2.88l-1.758 33.554 10.829-7.844c4.162-2.986 9.018-3.934 13.787-3.283 4.776.651 9.045 3.278 12.031 7.44 2.986 4.162 3.933 9.018 3.283 13.79Zm-16.423-15.28c-3.175-.567-6.812.044-9.334 2.315l-14.567 10.452-1.675 31.956 30.816-22.418c2.901-1.851 4.666-4.963 5.233-8.137.567-3.175-.044-6.812-2.315-9.334-1.871-2.502-4.983-4.267-8.158-4.834Zm-64.099 7.856c-.567 3.175.04 6.812 2.315 9.334 4.121 5.423 11.648 7.019 17.467 2.918l14.567-10.452 1.675-31.956-30.812 22.418c-2.505 1.872-4.649 4.563-5.212 7.738Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5860D6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8,
    d: "M367.444 179.946c.429-25.583-7.844-41.594-17.128-49.038"
  })));
};
export default SvgShore404;